import { render, staticRenderFns } from "./CreationList.vue?vue&type=template&id=06e62ab2&scoped=true&"
import script from "./CreationList.vue?vue&type=script&lang=js&"
export * from "./CreationList.vue?vue&type=script&lang=js&"
import style0 from "./CreationList.vue?vue&type=style&index=0&id=06e62ab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e62ab2",
  null
  
)

export default component.exports